
export default {
  name: 'important-notice',
  props: {
    value: { type: Boolean, default: false },
    landlordId: { type: [Number, String], default: null },
    title: { type: String, default: '個別重要通知' },
    hint: { type: String, default: '' },
    manual: { type: Boolean, default: false },
    pending: { type: Boolean, default: false }
  },
  data: function () {
    return {
      body: '',
      busy: false
    };
  },
  computed: {
    opened: function () {
      return this.value;
    },
    locked: function () {
      return this.busy || this.pending;
    }
  },
  watch: {
    value: function (opened) {
      if (!opened) return;
      this.body = '';
      this.busy = false;
      var t = this;
      this.$nextTick(function () {
        if (t.$refs.input) t.$refs.input.focus();
      });
    }
  },
  methods: {
    toast: function (msg) {
      if (window.A && A.toast) A.toast(msg);
    },
    close: function () {
      this.$emit('input', false);
    },
    onCancel: function () {
      if (this.locked) return;
      this.close();
    },
    onSend: function () {
      var t = this;
      if (t.locked) return;
      var text = (t.body || '').trim();
      if (!t.landlordId) {
        t.toast('オーナーが指定されていません');
        return;
      }
      if (!text) {
        t.toast('内容を入力してください');
        return;
      }
      if (t.manual) {
        t.$emit('send', text);
        return;
      }
      t.busy = true;
      axios.post('landlord/' + t.landlordId + '/notices', { body: text }).then(function (res) {
        t.busy = false;
        if (res.data.status != 1) {
          t.toast((res.data && res.data.msg) || '送信に失敗しました');
          return;
        }
        t.toast('送信しました');
        t.$emit('sent');
        t.close();
      }).catch(function () {
        t.busy = false;
        t.toast('通信に失敗しました');
      });
    }
  }
};
